module.exports = __webpack_public_path__ + "static/media/dragdrop.8ea5a1a8.svg";